import { Typography } from '@material-ui/core';
import React, { useMemo, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { colors } from '@/styles';
import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined';

export default function FileDropZone({
    disabled,
    handleFileAdd,
    customStyle,
    customLabel,
    type = 'single',
    error = false,
}) {
    const { acceptedFiles, getRootProps, getInputProps, isDragAccept, isDragReject, isDragActive } = useDropzone({
        accept: 'image/*, .pdf',
    });

    useEffect(() => {
        const fileTypesMap = {
            'application/pdf': 'pdf',
            'image/png': 'png',
            'image/jpeg': 'jpg',
            'image/jpg': 'jpg',
        };

        if (acceptedFiles.length > 0) {
            if (type === 'single') {
                const fileType = fileTypesMap[acceptedFiles[0].type];
                handleFileAdd(acceptedFiles[0], fileType);
            } else {
                const filesArray = [];
                acceptedFiles.forEach((file) => {
                    const fileType = fileTypesMap[file.type];
                    filesArray.push({ file, fileType });
                });
                handleFileAdd(filesArray);
            }
        }
    }, [acceptedFiles]);

    const baseStyle = {
        height: '100px',
        width: '100px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f4f4f4',
        borderRadius: '4px',
        border: error ? `1px solid ${colors.reds.primary}` : '1px solid #9d9d9d',
        fontFamily: 'Montserrat',
        cursor: 'pointer',
    };

    const style = useMemo(
        () => ({
            ...(customStyle ? customStyle : baseStyle),
        }),
        [isDragAccept, isDragReject, isDragActive, error]
    );
    return (
        <div {...getRootProps({ className: 'dropzone', style })}>
            <input {...getInputProps({ disabled: disabled })} />
            <div style={{ textAlign: 'center', padding: '10px 0' }}>
                <PublishOutlinedIcon style={{ color: '#2B2B2B' }} />
                <Typography style={{ fontSize: '14px', color: '#2B2B2B' }}>
                    {customLabel ? customLabel : 'Upload Document'}
                </Typography>
            </div>
        </div>
    );
}
